import React from 'react';
import { ErrorpageStyles } from '../Styles/ErrorpageStyles';

export default function Errorpage() {
  return(
    <ErrorpageStyles>
      <h1>This Page Doesn't Exist</h1>
    </ErrorpageStyles>
  ) 
}
